import { NgModule } from '@angular/core';
import { OKTA_CONFIG, OktaAuthModule } from '@okta/okta-angular';
import { OktaAuthService } from '../core/services/http/okta-auth.service';

function getConfiguration(oktaAuthService: OktaAuthService) {
    return { oktaAuth: oktaAuthService.getClient() };
}

@NgModule({
    imports: [OktaAuthModule],
    providers: [
        {
            provide: OKTA_CONFIG,
            useFactory: getConfiguration,
            deps: [OktaAuthService]
        }
    ]
})
export default class OktaModule {}
